import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Activity, Settings, X } from 'lucide-react';
import { TRANSITIONS } from '../../../utils/animations';
import ActivityMonitor from './ActivityMonitor';
import UserStats from './UserStats';
import AdminSettings from './AdminSettings';

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState<'activity' | 'users' | 'settings'>('activity');
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          {/* Header */}
          <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
            <button
              onClick={handleClose}
              className={`p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100 ${TRANSITIONS.DEFAULT}`}
              title="Return to user dashboard"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {/* Navigation */}
          <div className="border-b border-gray-200">
            <nav className="flex">
              <button
                onClick={() => setActiveTab('activity')}
                className={`${
                  activeTab === 'activity'
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } flex items-center px-6 py-4 border-b-2 font-medium text-sm transition-colors`}
              >
                <Activity className="h-5 w-5 mr-2" />
                Activity Monitor
              </button>

              <button
                onClick={() => setActiveTab('users')}
                className={`${
                  activeTab === 'users'
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } flex items-center px-6 py-4 border-b-2 font-medium text-sm transition-colors`}
              >
                <Users className="h-5 w-5 mr-2" />
                User Statistics
              </button>

              <button
                onClick={() => setActiveTab('settings')}
                className={`${
                  activeTab === 'settings'
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } flex items-center px-6 py-4 border-b-2 font-medium text-sm transition-colors`}
              >
                <Settings className="h-5 w-5 mr-2" />
                Settings
              </button>
            </nav>
          </div>

          {/* Content */}
          <div className="p-6">
            {activeTab === 'activity' && <ActivityMonitor />}
            {activeTab === 'users' && <UserStats />}
            {activeTab === 'settings' && <AdminSettings />}
          </div>
        </div>
      </div>
    </div>
  );
}